var _path, _path2, _g, _g2, _g3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1000,
    height: 1000,
    viewBox: "0 0 1000 1000",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.2514 584.282C31.9162 532.093 31.9162 467.752 60.2514 415.562L209.562 140.594C237.897 88.2484 290.604 56 347.568 56H645.602C702.566 56 755.126 88.2484 783.608 140.594L932.919 415.562C961.254 467.752 961.254 532.093 932.919 584.282L783.608 859.406C755.126 911.752 702.566 944 645.602 944H347.568C290.604 944 238.044 911.752 209.562 859.406L60.2514 584.282Z",
    fill: "#0C0C0C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M515.778 470.705L340.041 147.13L294.088 175.328L469.972 499.215L294.088 822.945L340.041 851.143L516.072 527.101H869.015V470.705H515.778ZM501.684 499.37L501.244 499.059L501.684 498.747V499.37Z",
    fill: "url(#paint0_radial_74_1458)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_74_1458)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.152 581.315C84.1107 531.151 84.1107 468.835 112.152 418.671L176.898 302.764L238.854 185.454C265.721 134.511 316.812 103.198 371.868 103.977L498.275 105.535L624.683 103.977C679.739 103.198 730.83 134.511 757.697 185.454L819.653 302.764L884.398 418.671C912.44 468.835 912.44 531.151 884.398 581.315L819.653 697.223L757.697 814.532C730.83 865.475 679.739 896.789 624.683 896.01L498.275 894.452L371.868 896.01C316.812 896.789 265.721 865.475 238.854 814.532L176.898 697.223L112.152 581.315ZM157.812 447.337C139.754 479.741 139.754 520.09 157.812 552.65L222.704 668.869C222.851 669.025 222.851 669.336 222.998 669.492L285.1 787.113C302.571 820.141 335.605 840.393 371.134 839.926L497.982 838.368C498.129 838.368 498.422 838.368 498.569 838.368L625.417 839.926C661.093 840.393 694.126 820.141 711.451 787.113L773.553 669.492C773.7 669.336 773.7 669.025 773.847 668.869L838.739 552.65C856.797 520.246 856.797 479.897 838.739 447.337L773.847 331.118C773.7 330.962 773.7 330.65 773.553 330.494L711.451 212.873C693.98 179.846 660.946 159.593 625.417 160.061L498.569 161.619C498.422 161.619 498.129 161.619 497.982 161.619L371.134 160.061C335.458 159.593 302.424 179.846 285.1 212.873L222.998 330.494C222.851 330.65 222.851 330.962 222.704 331.118L157.812 447.337Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_74_1458)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M361.233 277.994C367.546 265.998 379.585 258.676 392.505 258.832L502.616 260.234L612.727 258.832C625.647 258.676 637.685 265.998 643.999 277.994L698.173 380.503C707.716 398.575 701.697 421.476 684.519 431.602C667.489 441.729 645.907 435.341 636.364 417.114L592.467 334.078L502.909 335.169C502.616 335.169 502.322 335.169 502.029 335.169L412.472 334.078L368.574 417.114C368.427 417.425 368.28 417.581 368.133 417.893L322.327 499.838L368.133 581.783C368.28 582.095 368.427 582.251 368.574 582.562L412.472 665.598L502.029 664.508C502.322 664.508 502.616 664.508 502.909 664.508L592.467 665.598L636.364 582.562C645.907 564.491 667.489 557.948 684.519 568.074C701.55 578.2 707.716 601.101 698.173 619.173L643.999 721.682C637.685 733.678 625.647 741 612.727 740.844L502.616 739.442L392.505 740.844C379.585 741 367.546 733.678 361.233 721.682L307.352 619.484L251.122 518.689C244.515 506.849 244.515 492.204 251.122 480.364L307.352 379.569L361.233 277.994Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_74_1458)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M463.643 409.642C451.751 402.632 437.216 411.668 437.216 426V577.739C437.216 592.072 451.897 601.108 463.643 594.097L504.178 569.824L527.272 614.188C534.466 627.897 550.616 632.727 563.389 625.249C576.308 617.615 580.86 600.478 573.813 586.925L550.478 542.1L590.344 518.228C602.383 511.061 602.383 492.678 590.344 485.512L463.643 409.642Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_74_1458",
    x: 5.78071,
    y: 35.6901,
    width: 984.989,
    height: 962.743,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 17.0681
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 42.6702
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_74_1458"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_74_1458",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_74_1458",
    x: 160.827,
    y: 190.557,
    width: 627.212,
    height: 652.698,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 17.0681
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 42.6702
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_74_1458"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_74_1458",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_74_1458",
    x: 351.875,
    y: 338.946,
    width: 332.838,
    height: 392.221,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 17.0681
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 42.6702
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_74_1458"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_74_1458",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_74_1458",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(498.053 503.175) scale(357.196 379.076)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C0C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.33281e58f878bf67f336e6e9f8054353.svg";
export { ForwardRef as ReactComponent };